const ClubMembersMain = () => import(/*webpackChunkName: 'club-members'*/ '@/views/ClubMembers.vue');
const ClubMembers = () => import(/*webpackChunkName: 'club-members'*/ '@/components/club-members/ClubMembers.vue');
const ClubMembersEditMember = () =>
    import(/*webpackChunkName: 'club-members'*/ '@/components/club-members/ClubMembersEditMember.vue');
import { ROUTES_CLUB_MEMBERS, ROUTES_EDIT_CLUB_MEMBER_ROLES, ROUTES_UNAUTHORIZED } from '@/constants/routes';
import store from '@/store';
import { i18n } from '@/lang';

export default {
    path: '/club-members',
    name: 'club-members-main',
    component: ClubMembersMain,
    children: [
        {
            path: '/club-members',
            name: ROUTES_CLUB_MEMBERS,
            beforeEnter: guardRouteClubMembers,
            component: ClubMembers
        },
        {
            path: '/club-members/edit',
            name: ROUTES_EDIT_CLUB_MEMBER_ROLES,
            beforeEnter: guardRouteClubMembers,
            component: ClubMembersEditMember
        }
    ]
};

function guardRouteClubMembers(to, from, next) {
    if (store.getters.isSelectedClubIndividual || !store.getters['userPermissions/canViewClubMembers']) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_UNAUTHORIZED });
    } else {
        next();
    }
}
